<div class="alert" role="text" [attr.aria-label]="text">
  <span class="alert__icon" aria-hidden="true">
    <img src="assets/images/svg/icon-alert.svg" alt="icon">
  </span>
  <span class="alert__text" aria-hidden="true">{{text}}</span>
</div>
